module.exports = __webpack_public_path__ + "4ece25d68206965bedda120322c99776.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/sandwich-s.png
// module id = 2724
// module chunks = 0